import React, { useState , useEffect } from "react";
//import ReactExport from "react-data-export";
import { PageTitle } from "../ui/PageTitle";
import SwiperCore, { Navigation, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "./assets/contacts.scss";
import style from  "./assets/style.module.css";

import { useTranslation } from 'react-i18next';
import http from "../ui/Services";

import {Row, Col, Collapse, Tooltip} from 'antd'
import { BsBank, BsBuilding,  BsEnvelope,  BsFillEnvelopeFill,  BsFillTelephoneFill,  BsPerson } from "react-icons/bs";
import {  AiOutlineFieldNumber, AiOutlinePhone } from "react-icons/ai";
import {  GiBanknote, GiMailbox, GiReceiveMoney } from "react-icons/gi";
import { MdFormatListNumbered, MdOutlinePlace } from "react-icons/md";

import { FaBuilding, FaMapMarkerAlt, FaRegEnvelope } from "react-icons/fa";
import { ImUserTie } from "react-icons/im";
import { region, regionI } from "../../host";

// import BounceLoader from "react-spinners/BounceLoader";
const { Panel } = Collapse;


//const ExcelFile = ReactExport.ExcelFile
//const ExcelSheet = ReactExport.ExcelFile.ExcelSheet

SwiperCore.use([Navigation, Autoplay]);


function Contacts() {
  const [index, setIndex]= useState(1)
  const {t} = useTranslation();
  const [number, setNumber]=useState(0)
  const[data , setData] = useState<any[]>([])
  const [loader, setLoader] = useState(true)
  const [loadError, setLoadError] = useState(false)
  const[regionD , setRegionD] = useState<any[]>([])

//  const DataSet=[{
//    columns:[

//{title:'T/r', style:{font: {sz:'16', bold:true}}},
//{title:'Tashkilot nomi',style:{font: {sz:'16', bold:true}}},
//{title:'Manzil',style:{font: {sz:'16', bold:true}}},
//{title:'Ism',style:{font: {sz:'16', bold:true}}},
//{title:'Telefon',style:{font: {sz:'16', bold:true}}},
//{title:'Email',style:{font: {sz:'16', bold:true}}},

//    ],
//    data:data[index - 1].map((item, index)=>[
//      {value:item.index+1, style:{font:{sz:"14"}}},
//      {value:item.item.branchName, style:{font:{sz:"14"}}},
//      {value:item.item.branchAdress, style:{font:{sz:"14"}}},
//      {value:item.item.branchPresident, style:{font:{sz:"14"}}},
//      {value:item.item.phoneNumber, style:{font:{sz:"14"}}},
//      {value:item.item.email, style:{font:{sz:"14"}}},
//    ])
//  }]
  async function getContacts(){
   
    await http.get('GetApi/GetRegionContacts')
    .then((res) => {
       var b=[]
      
       b.push(res.data.filter((data: any) => data.regionId === region))

    
       setRegionD(b)
  
    })
    .catch(() => setLoadError(true))
    try {
    const res = await http('/GetApi/GetBranchContacts')
   var a=[]
      a.push(res.data.filter((data: any) => data.regionId === regionI))
    setData(a)
    } catch {
      setLoadError(true)
    } finally {
      setLoader(false)
    }
  }
  
useEffect(()=>{
    getContacts();
  },[])
  const callback=(key:any)=> {
    setNumber(key)
    console.log(key)
  }
  
  
  return (
    <div className="contacts tr">
      
      {loader?<div className={style.loader}>
      <div className={style.bef}>
      <img src="https://vatanparvar.uz/Files/images/logo.gif" alt="..."/>
      </div>
      </div>
      :''}
      <div className="containerr">
      <PageTitle title={t("KONTAKTLAR")}/>
      {loadError && <p role="alert">{t("check") ? "Kontakt maʼlumotlarini yuklab bo‘lmadi. Sahifani yangilab qayta urinib ko‘ring." : "Не удалось загрузить контактные данные. Обновите страницу и попробуйте снова."}</p>}
        <div className="tel">
        
        
        <div className="sal">
                      <Collapse onChange={callback} accordion>
                      <Panel className={`${0===Number(number)?"Active":''} panel`}  style={{zIndex:-1}} key={0} header={
                              <div className={style.headAcc}>
                              <div style={{zIndex:-1}} className={style.headId}>{1}</div>
                              <div style={{zIndex:-1}} className={style.headName}><BsBuilding color="#133165"/>  {regionD[index - 1]?.[0] != null?t('check')?regionD[index - 1][0].regionName:regionD[index - 1][0].regionNameRu:''}</div>
                             </div>}>
                             <Row  style={{paddingLeft:"calc(5%)", paddingRight:'5%'}}>
<Col style={{padding:'10px'}} className="colAcc" lg={8} md={12} sm={24}>
  <BsPerson size='1.3rem'  color="#133165" /><span className="salomText">{regionD[index - 1]?.[0] != null?t('check')?(regionD[index - 1][0].regionPresident && regionD[index - 1][0].regionPresident!==null?regionD[index - 1][0].regionPresident:regionD[index - 1][0].regionPresidentRu && regionD[index - 1][0].regionPresidentRu!==null?regionD[index - 1][0].regionPresidentRu:<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>):regionD[index - 1][0].regionPresidentRu && regionD[index - 1][0].regionPresidentRu!==null?regionD[index - 1][0].regionPresidentRu:regionD[index - 1][0].regionPresident && regionD[index - 1][0].regionPresident!==null?regionD[index - 1][0].regionPresident:<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:''}</span>
  </Col>
  <Col style={{padding:'10px'}} className="colAcc" lg={8} md={12} sm={24}>
  <AiOutlinePhone size='1.3rem'  color="#133165" /><span className="salomText">{regionD[index - 1]?.[0] != null?regionD[index - 1][0].phoneNumber===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:regionD[index - 1][0].phoneNumber:''}</span>
  </Col>
 
  
  <Col className="colAcc" lg={8} md={12} sm={24}>
  <Tooltip placement="left" title={t("Tashkilot manzili")}><FaMapMarkerAlt  color="#133165" size='1.4rem' />  <span className="salomText">{regionD[index - 1]?.[0] != null?t('check')?(regionD[index - 1][0].regionAdress && regionD[index - 1][0].regionAdress!==null?regionD[index - 1][0].regionAdress:regionD[index - 1][0].regionAdressRu && regionD[index - 1][0].regionAdressRu!==null?regionD[index - 1][0].regionAdressRu:<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>):regionD[index - 1][0].regionAdressRu && regionD[index - 1][0].regionAdressRu!==null?regionD[index - 1][0].regionAdressRu:regionD[index - 1][0].regionAdress && regionD[index - 1][0].regionAdress!==null?regionD[index - 1][0].regionAdress:<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:''}</span></Tooltip>
  </Col>
 
  <Col className="colAcc" lg={8} md={12} sm={24}>
  <Tooltip placement="left" title={t("Pochta indeks")}><BsFillEnvelopeFill color="#133165" size='1.4rem'/> <span className="salomText">{regionD[index - 1]?.[0] != null?regionD[index - 1]?.[0] != null?regionD[index - 1][0].mailIndex===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:regionD[index - 1][0].mailIndex:'':''}</span></Tooltip>
  </Col>
  
</Row>
  </Panel>
                          {
                              data.length !== 0 ? data[index - 1].map((item: any, key: any) =>
                                  
                              <Panel className={`${key+1===Number(number)?"Active":''} panel`}  style={{zIndex:-1}} key={key+1} header={
                                <div className={style.headAcc}>
                                <div style={{zIndex:-1}} className="headId">{key+2}</div>
                                <div style={{zIndex:-1}} className="headName"><BsBuilding color="#133165"/> {t('check')?item.branchName:item.branchNameRu}</div>
                              </div>}>
  <Row style={{paddingLeft:"calc(5%)", paddingRight:'5%'}}>
  <Col style={{padding:'10px'}} className="colAcc" lg={8} md={12} sm={24}>
  <BsPerson size='1.3rem'  color="#133165" /><span className="salomText"> {t('check')?item.branchPresident===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:item.branchPresident:item.branchPresidentRu===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:item.branchPresidentRu}</span>
  </Col>
  <Col style={{padding:'10px'}} className="colAcc" lg={8} md={12} sm={24}>
  <AiOutlinePhone size='1.3rem'  color="#133165" /><span className="salomText"> {item.phoneNumber===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:item.phoneNumber}</span>
  </Col>

 
 
  
  <Col style={{padding:'10px'}} className="colAcc" lg={8} md={12} sm={24}>
  <FaMapMarkerAlt  color="#133165" size='1.3rem' />  <span className="salomText">{t('check')?item.branchAdress===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:item.branchAdress:item.branchAdressRu===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:item.branchAdressRu}</span>
  </Col>
 
  <Col style={{padding:'10px'}} className="colAcc" lg={8} md={12} sm={24}>
  <BsFillEnvelopeFill color="#133165" size='1.3rem'/> <span className="salomText">{item.mailIndex===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:item.mailIndex} </span>
  </Col>
    
  </Row>
                               
                              </Panel>
                    
                    ):''
                  }
                    </Collapse>
                    </div>
        </div>
        <div className="komp">
        <Row style={{width:'100%'}}>

<Col style={{padding:'5px'}} lg={24} md={24} sm={24}>
     
<div className="content">
        <table className="content-table table1" >
            <thead style={{backgroundColor:'white', height:'65px',}}  className={style.the}>
                          <tr>
                         <th className={style.id}>
                          <Tooltip placement="top" title={t("Tartib raqam")}>
                         <MdFormatListNumbered size='2rem' color="#133165"/>
                         </Tooltip>

                           </th>    
                <th className={style.name}>
                 <Tooltip placement="top" title={t("Tashkilot nomi")}>
                <FaBuilding  size='2rem' color="#133165"/>
                </Tooltip>
                  </th>
              
                <th className={style.person} style={{paddingLeft:'40px'}}>
                 <Tooltip placement="top" title={t("Tashkilot rahbari")}>
                <ImUserTie  size='2.1rem' color="#133165" />
                </Tooltip>
                </th>
               
                <th className={style.phone}>
                 <Tooltip placement="top" title={t("Telefon raqam")}>
                <BsFillTelephoneFill size='2rem' color="#133165" />
                </Tooltip>
                  </th>
                
              </tr>   
            </thead></table>
<div className={style.op}>
                      <Collapse onChange={callback} accordion>
                      <Panel className={`${0===Number(number)?"Active":''} panel`}  style={{zIndex:-1}} key={0} header={
                              <div className={style.headAcc}>
                              <div style={{zIndex:-1}} className={style.headId}>{1}</div>
                              <div style={{zIndex:-1}}  className={style.headName}> {regionD[index - 1]?.[0] != null?t('check')?regionD[index - 1][0].regionName:regionD[index - 1][0].regionNameRu:''}</div>
                              <div style={{zIndex:-1}} className={style.headPerson}>{regionD[index - 1]?.[0] != null?t('check')?regionD[index - 1][0].regionPresident:regionD[index - 1][0].regionPresidentRu:''}</div>
                              <div style={{zIndex:-1}} className={style.headPhone}>{regionD[index - 1]?.[0] != null?regionD[index - 1][0].phoneNumber===null?"-":regionD[index - 1][0].phoneNumber:''}</div>
                            </div>}>
                            <Row style={{paddingLeft:"calc(5% + 22px)"}}>
<Col className="colAcc" lg={8} md={12} sm={24}>
  <Tooltip placement="left" title={t("Tashkilot manzili")}><FaMapMarkerAlt  color="#133165" size='1.4rem' />  <span className="salomText">{regionD[index - 1]?.[0] != null?t('check')?(regionD[index - 1][0].regionAdress && regionD[index - 1][0].regionAdress!==null?regionD[index - 1][0].regionAdress:regionD[index - 1][0].regionAdressRu && regionD[index - 1][0].regionAdressRu!==null?regionD[index - 1][0].regionAdressRu:<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>):regionD[index - 1][0].regionAdressRu && regionD[index - 1][0].regionAdressRu!==null?regionD[index - 1][0].regionAdressRu:regionD[index - 1][0].regionAdress && regionD[index - 1][0].regionAdress!==null?regionD[index - 1][0].regionAdress:<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:''}</span></Tooltip>
  </Col>
<Col className="colAcc" lg={8} md={12} sm={24}>
  <Tooltip placement="left" title={t("Pochta indeks")}><BsFillEnvelopeFill color="#133165" size='1.4rem'/> <span className="salomText">{regionD[index - 1]?.[0] != null?regionD[index - 1][0].mailIndex===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:regionD[index - 1][0].mailIndex:''}</span></Tooltip>
  </Col>
  
</Row>
                            </Panel>
                          {
                              data.length !== 0 ? data[index - 1].map((item: any, key: any) =>
                                  {
                                    
                                    return(
                              <Panel className={`${key+1===Number(number)?"Active":''} panel`}  style={{zIndex:-1}} key={key+1} header={
                              <div className={style.headAcc}>
                              <div style={{zIndex:-1}} className={style.headId}>{key+2}</div>
                              <div style={{zIndex:-1}} className={style.headName}> {t('check')?item.branchName:item.branchNameRu}</div>
                              <div style={{zIndex:-1}} className={style.headPerson}>{item.branchPresident===null?"-":item.branchPresident}</div>
                              <div style={{zIndex:-1}} className={style.headPhone}>{item.phoneNumber===null?"-":item.phoneNumber}</div>
                            </div>}>
                            <Row style={{paddingLeft:"calc(5% + 22px)"}}>
 
  
  <Col className="colAcc" lg={8} md={12} sm={24}>
  <Tooltip placement="left" title={t("Tashkilot manzili")}><FaMapMarkerAlt  color="#133165" size='1.3rem' />  <span className="salomText">{t('check')?(item.branchAdress && item.branchAdress!==null?item.branchAdress:item.branchAdressRu && item.branchAdressRu!==null?item.branchAdressRu:<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>):item.branchAdressRu && item.branchAdressRu!==null?item.branchAdressRu:item.branchAdress && item.branchAdress!==null?item.branchAdress:<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>}</span></Tooltip>
  </Col>
 
  <Col className="colAcc" lg={8} md={12} sm={24}>
  <Tooltip placement="left" title={t("Pochta indeks")}><BsFillEnvelopeFill color="#133165" size='1.3rem'/> <span className="salomText">{item.mailIndex===null?<span style={{color:'#a2a0a0'}}>{t("Ma'lumot mavjud emas")}</span>:item.mailIndex} </span></Tooltip>
  </Col>
  
</Row>
                            </Panel>
                    )}
                    ):''
                  }
                    </Collapse>
                    </div>
        </div>

        
</Col>
        </Row>
        </div>
      
                    
                   

        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      </div>
    </div>
  );
}
export default Contacts;
